export enum SOCKET_EVENTS {
  LOGOUT = "LOGOUT",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  REMOVE_LOGIN = "REMOVE_LOGIN",
  USER_CONNECTED = "USER_CONNECTED",
}
